"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var SingleLineViewSubjectLine = /** @class */ (function (_super) {
    tslib_1.__extends(SingleLineViewSubjectLine, _super);
    function SingleLineViewSubjectLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleLineViewSubjectLine.prototype.render = function () {
        var subjectClasses = classNames(this.props.isUnread ? styles.subjectUnread : styles.subject, 'fbAdTitle', 'fbAdLink');
        return (React.createElement("div", { className: subjectClasses },
            this.props.originalPriceTexts && (React.createElement("span", { className: styles.originalPrice },
                this.props.originalPriceTexts,
                " \u00A0")),
            this.props.currentPriceTexts && React.createElement("span", null,
                this.props.currentPriceTexts,
                " \u00A0"),
            this.props.subjectTexts));
    };
    SingleLineViewSubjectLine = tslib_1.__decorate([
        mobx_react_1.observer
    ], SingleLineViewSubjectLine);
    return SingleLineViewSubjectLine;
}(React.Component));
exports.default = SingleLineViewSubjectLine;
//# sourceMappingURL=SingleLineViewSubjectLine.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/SingleLineViewSubjectLine.js
// module id = 6001
// module chunks = 67